import { render, staticRenderFns } from "./RegisterOrganisation.vue?vue&type=template&id=26e61b3d&scoped=true"
import script from "./RegisterOrganisation.vue?vue&type=script&lang=js"
export * from "./RegisterOrganisation.vue?vue&type=script&lang=js"
import style0 from "./RegisterOrganisation.vue?vue&type=style&index=0&id=26e61b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e61b3d",
  null
  
)

export default component.exports